import { useEffect, useMemo, useState } from 'react';
import { Box, Button, Callout, CloseButton, Row } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStore, useStoreActions } from "../../contexts";
import { useCreateVendorAccount } from "../../hooks/useCreateVendorAccount/useCreateVendorAccount";
import { selectors } from "../../store/state-selectors";
import styles from "./HomePage.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetAnchorForBusinessBannerTID = parentTestId => getTestIds(parentTestId);
export function AnchorForBusinessBanner() {
  const {
    AnchorForBusinessBannerTID
  } = useMemo(() => GetAnchorForBusinessBannerTID(), []);
  const isClient = useStore(selectors.user.isClient);
  const isVendor = useStore(selectors.user.isVendor);
  const isAccountant = useStore(selectors.user.isAccountant);
  const hasAVendorAccount = useStore(state => {
    var _state$userInfo;
    return (_state$userInfo = state.userInfo) === null || _state$userInfo === void 0 ? void 0 : _state$userInfo.hasAVendorAccount();
  });
  const userClientData = useStore(state => state.userClientData);
  const {
    updateUserClientData,
    logBI
  } = useStoreActions();
  const onCreateVendorAccount = useCreateVendorAccount(() => logBI(19201));
  const [isDismissed, setIsDismissed] = useState((userClientData === null || userClientData === void 0 ? void 0 : userClientData.anchorForBusinessBannerDismissed) === true);
  useEffect(() => {
    setIsDismissed((userClientData === null || userClientData === void 0 ? void 0 : userClientData.anchorForBusinessBannerDismissed) === true);
  }, [userClientData === null || userClientData === void 0 ? void 0 : userClientData.anchorForBusinessBannerDismissed]);
  const shouldShow = useMemo(() => isClient && !isVendor && !hasAVendorAccount && !isAccountant && !isDismissed, [isClient, isVendor, hasAVendorAccount, isAccountant, isDismissed]);
  useEffect(() => {
    if (shouldShow) {
      logBI(19200);
    }
  }, [shouldShow, logBI]);
  const handleDismiss = async () => {
    logBI(19202);
    setIsDismissed(true);
    await updateUserClientData({
      anchorForBusinessBannerDismissed: true
    });
  };
  if (!shouldShow) {
    return null;
  }
  return /*#__PURE__*/_jsx(Box, {
    className: styles.anchorForBusinessBannerContainer,
    children: /*#__PURE__*/_jsx(Callout, {
      hideIcon: true,
      intent: "info",
      testId: AnchorForBusinessBannerTID.Root(),
      classes: {
        wrapper: styles.anchorForBusinessBannerWrapper,
        main: styles.anchorForBusinessBannerMain
      },
      withAction: /*#__PURE__*/_jsxs(Row, {
        alignItems: "center",
        gap: 8,
        className: styles.anchorForBusinessBannerButtons,
        children: [/*#__PURE__*/_jsx(Button, {
          size: "small",
          testId: AnchorForBusinessBannerTID.GetStartedButton(),
          skin: "primary",
          onClick: onCreateVendorAccount,
          bi: {
            name: 'get_started_free'
          },
          children: "Get started for free"
        }), /*#__PURE__*/_jsx(CloseButton, {
          onClick: handleDismiss,
          testId: AnchorForBusinessBannerTID.DismissButton()
        })]
      }),
      children: "Try Anchor for your business - send proposals, bill, and get paid. As simple as that."
    })
  });
}